import {
  CITY_EVENTS_FETCH,
  CITY_EVENTS_FETCH_FAIL,
  CITY_EVENTS_FETCH_SUCCESS,
  CITY_EVENTS_SAVE,
  CITY_EVENTS_SAVE_FAIL,
  CITY_EVENTS_SAVE_SUCCESS,
  CITY_EVENTS_UPDATE
} from '../actions/city_events';

import { CmsEditorState } from '../api/club-cms';

const initialState = {
  loading: false,
  saving: false,
  cmsEditorState: new CmsEditorState(),
  model: null
};

export default function settings(state = initialState, action) {
  switch (action.type) {
    case CITY_EVENTS_FETCH:
      return Object.assign({}, state, {
        loading: true,
        model: null,
        cmsEditorState: state.cmsEditorState
      });

    case CITY_EVENTS_FETCH_FAIL:
      return Object.assign({}, state, {
        loading: false,
        model: action.cityEvents,
        cmsEditorState: state.cmsEditorState
      });

    case CITY_EVENTS_FETCH_SUCCESS:

      const cmsEditorState = state.cmsEditorState.parse(action.cityEvents || []);

      return Object.assign({}, state, {
        loading: false,
        model: action.cityEvents,
        cmsEditorState: cmsEditorState
      });

    case CITY_EVENTS_UPDATE:
      return Object.assign({}, state, {
        cmsEditorState: action.cmsEditorState
      });

    case CITY_EVENTS_SAVE:
      return Object.assign({}, state, {
        saving: true
      });

    case CITY_EVENTS_SAVE_FAIL:
      return Object.assign({}, state, {
        saving: false
      });

    case CITY_EVENTS_SAVE_SUCCESS:
      return Object.assign({}, state, {
        saving: false
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/city_events.js